import React from 'react';

const SelectLocal = ({ selectOption=[], label, name, formik, required = false ,optionValue=(item)=>item.id,optionTitle=(item)=>item.title}) => {

    
    return (

             <div className="form-group">
                <label htmlFor={name}> {label} </label>
                <select
                    required={required}
                    className={`form-control ${formik.errors[name] ? 'is-invalid' : ''}`}
                    name={name}
                    {...formik?.getFieldProps(name)}
                >
                    <option  value="" >انتخاب کنید</option>
                    {selectOption.map((item) => (
                        <option key={optionValue(item)} value={optionValue(item)}>{optionTitle(item)}</option>
                    ))}
                </select>
                {formik?.errors[name] && formik.touched[name] && (
                    <div className='errorText'> {formik.errors[name]} </div>
                )}
         </div>

    )
    
}

export default SelectLocal